const extraMadelin = () => null;

export default extraMadelin;
